import { action, makeObservable, observable } from 'mobx';
import { persist } from 'mobx-persist';
import { localeStore } from '../localesStore';
import { RESTRICTION_ACCESS, screensWithPosNotifications } from 'src/constants/integrations';
import { appStore } from 'src/mobx/appStore';
import client from 'src/services/client';
import { history } from 'src/services/history';
import { TPosRestrictionSettings } from 'src/types/integrations';
import { findSubstringInArray } from 'src/utils/parser';
import logger from '~/services/logger';
import { removeToast, toastError } from '~/utils/toasts';

const integrationRestrictToastId: string = 'integration-restrict-toast-id';

export class IntegrationsStore {
  constructor() {
    makeObservable(this);
  }

  public get persist() {
    return true;
  }

  @persist('object') @observable public posRestrictions: TPosRestrictionSettings | null = null;

  @action fetchPosRestrictionsSettings = async () => {
    try {
      const posRestrictions = await client.get('v3/restrictions');
      this.posRestrictions = { ...this.posRestrictions, ...posRestrictions };
    } catch (error: any) {
      logger.error({ error, place: 'IntegrationsStore fetchPosRestrictionsSettings' });
    }
  };

  @action integrationNotification = () => {
    if (!appStore.settings?.is_pos) return;

    if (findSubstringInArray(history.location.pathname, screensWithPosNotifications)) {
      toastError({ id: integrationRestrictToastId, message: localeStore.t('pos_int_on') });
      return;
    }

    removeToast(integrationRestrictToastId);
  };

  afterHydration = () => {
    this.fetchPosRestrictionsSettings();
  };
}

const integrationsStore = new IntegrationsStore();

export default integrationsStore;
